// src/lib/authGroups.js
import { Auth } from "aws-amplify";

export function isSupportUser(claims) {
  const grp =
    claims?.["cognito:groups"] ||
    claims?.["https://cognito-idp.amazonaws.com/groups"] ||
    claims?.["groups"] ||
    claims?.["custom:groups"] ||
    null;

  if (!grp) return false;

  let groups = [];

  if (Array.isArray(grp)) {
    groups = grp;
  } else if (typeof grp === "string") {
    // handle JSON-ish strings or comma lists
    try {
      const parsed = JSON.parse(grp);
      groups = Array.isArray(parsed) ? parsed : grp.split(",");
    } catch {
      groups = grp.split(",");
    }
  } else {
    return false;
  }

  groups = groups.map((g) => String(g).replace(/[\[\]]/g, "").trim());
  return groups.includes("Admin") || groups.includes("Support");
}

export async function getUserClaims() {
  const user = await Auth.currentAuthenticatedUser();
  return user?.signInUserSession?.idToken?.payload || {};
}

export async function isCurrentUserSupport() {
  try {
    const claims = await getUserClaims();
    return isSupportUser(claims);
  } catch {
    return false;
  }
}
